export default {
  isStaffLedCampaign(state) {
    return state.values.staffLedCampaign === true
  }
}
